import { gql, useMutation } from 'urql';

export const UPDATE_CATEGORY_MUTATION = gql`
  mutation ($categoryId: Int!, $title: String!, $description: String, $color: ColorEnum) {
    updateCategory(input: { categoryId: $categoryId, title: $title, description: $description, color: $color }) {
      id
      title
      description
      eventId
      countTicket
      color
    }
  }
`;

export interface UpdateCategoryVariables {
  categoryId: number;
  title: string;
  description?: string | null;
  color?: string;
}

export interface UpdateCategoryResponse {
  updateCategory: {
    id: number;
    title: string;
    description: string | null;
    eventId: number;
    countTicket: number;
    color?: string;
  };
}

export const useFetchUpdateCategory = () => {
  const [result, executeMutation] = useMutation<UpdateCategoryResponse, UpdateCategoryVariables>(
    UPDATE_CATEGORY_MUTATION
  );
  return { updateCategory: executeMutation, fetching: result.fetching };
};
